// must be the very first import: clears out stale/incompatible localStorage
// before any other module (AppStore, FinancingStore, firebase.ts, …) reads it.
import './source/framework/utils/clearStaleLocalStorage';
// before React's first commit: keeps translated pages from crashing React (ADV-282)
import './source/framework/utils/tolerateTranslatedDom';
import './reflect-fix';
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { i18nextInstance } from './i18n';
import AppStore from './source/AppStore';
import config from './config/app.config';
import { setStrictConditionOwners } from '@bytebrand/fe-ui-core-autobahn/utils';
import AppProvider from './source/AppProvider';
/* UNCOMMENT THIS IN CASE IF YOU NEED TO DEBUG mobx-rect-forms */
// import MobxReactFormDevTools from 'mobx-react-form-devtools';
// import VehicleAddByDataForm from './source/components/pages/VehicleAddPage/forms/VehicleAddByDataForm';
// import { VehicleEditForm } from './source/components/pages/VehicleEditPage/forms/Form';
// import LoginForm from './source/components/pages/AuthPage/forms/LoginForm';
// import RegisterForm from './source/components/pages/AuthPage/forms/RegisterForm';
// import ContactDetailsForm from './source/components/pages/SettingsPage/forms/ContactDetailsForm';
// import DataUsageForm from './source/components/pages/SettingsPage/forms/DataUsageForm';
//
// MobxReactFormDevTools.register({
//   VehicleAddByDataForm,
//   VehicleEditForm,
//   DataUsageForm,
//   ContactDetailsForm,
//   LoginForm,
//   RegisterForm
// });
//
// MobxReactFormDevTools.select('VehicleEditForm');
// MobxReactFormDevTools.open(true);
setStrictConditionOwners(config.strictConditionOwnerIds || []);
const root = createRoot(document.getElementById('app-root'));
root.render(React.createElement("div", null,
    React.createElement(AppProvider, { store: AppStore, i18next: i18nextInstance })));
if (process.env.NODE_ENV === 'development' && module.hot) {
    module.hot.accept();
}
